<template>
  <div class="quill-editor-container">
    <div class="subTitle">
      <span class="blue-border"></span>
      <span class="title-text-left">转接申请</span>
    </div>

    <div class="quill-editor-main-content">
      <div class="quill-editor-box">
        <quill-editor ref="myQuillEditor" :content="quillContents" :options="editorOption"
                      @change="onEditorChange($event)"/>
      </div>
      <div class="quill-editor-options-box">
        <div class="upload-file">
          <span class="upload-text-btn" @click="uploadFile">上传附件<i class="el-icon-paperclip"/></span>
          <span class="upload-limit">单个文件不能超过20MB</span>
        </div>
        <div class="quill-editor-button-box">
          <el-button size="small" type="primary">新发起</el-button>
          <el-button size="small" type="primary">关闭工单</el-button>
          <el-button size="small">返回</el-button>
          <el-button size="small" type="primary">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {quillEditor, Quill} from "vue-quill-editor";
import VideoBlot from "plus/plugins";

//Quill.register(VideoBlot);

export default {
  name: "quillEditor",
  components: {
    quillEditor
  },
  data() {
    return {
      quillContents: '',
      editorOption: {
        placeholder: "请输入正文内容，不超过1000字",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["code-block"],
            [{header: 1}, {header: 2}],
            [{script: "sub"}, {script: "super"}],
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            [{color: []}, {background: []}],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      }
    }
  },
  methods: {
    uploadFile() {

    },
    onEditorChange({quill, html, text}) {
      // ;
      const textLimit = 20000;
      if (text.length <= textLimit) {
        this.contents = html;
      } else {
        const range = quill.getLength();
        quill.deleteText(textLimit, range);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.quill-editor-container {
  padding: 28px 46px 32px;
  border-top: 1px solid #e2e2e2;
  box-sizing: border-box;

  .quill-editor-main-content {
    width: 100%;
    padding: 20px 0 0 95px;
    box-sizing: border-box;
  }

  .quill-editor-box {
    width: 100%;
    height: calc(365px + 40px);

    .quill-editor {
      height: calc(100% - 42px);
    }
  }

  .quill-editor-options-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-top: 30px;

    .upload-file {
      font-size: 14px;

      .upload-text-btn {
        color: #3572E2;
        margin-right: 12px;
      }

      .upload-limit {
        color: #999;
      }
    }

    .quill-editor-button-box {
      .el-button {
        width: 104px;
        height: 36px;
        border-radius: 2px;
        font-size: 14px;
      }
    }
  }
}

</style>
